import { IconProps } from '../icon';
import svg from './row-svg/check-v1.svg';

export function CheckV1Icon(props: IconProps) {
  return <img src={svg} alt="svg" />;
}

export default CheckV1Icon;
